import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  bulkFileTitle: {
    fontWeight: 500,
    color: theme.palette.grey[700],
    marginTop: theme.spacing(1),
    '& a': {
      fontSize: 12,
      marginInlineStart: theme.spacing(1),
      color: theme.palette.primary.main,
      background: theme.palette.primary.light,
      padding: theme.spacing(0.5, 1.5),
      borderRadius: 20,
    },
  },
  bulkFileIcon: {
    color: theme.palette.grey[700],
    fontSize: 20,
    marginBottom: -6,
    marginInlineStart: theme.spacing(1),
    marginInlineEnd: theme.spacing(1),
  },
  radioItem: {
    border: '1px solid #dfdfdf',
    borderRadius: 8,
    padding: theme.spacing(1),
    boxSizing: 'border-box',
    display: 'block',
    marginInlineEnd: theme.spacing(0),
    marginInlineStart: 0,
    transition: "all .1s ease-in",
    '&.active': {
      background: '#eceff1',
      borderColor: '#2B3990'
    },
  },
  radioIcon: {
    color: '#2b3990',
    fontSize: 25,
    display: 'inline-block',
    float: 'right',
    marginTop: '4px',
    marginRight: '8px',
  },
  radioText: {
    color: '#2b3940',
    fontSize: 14,
    textOverflow: 'ellipsis',
    overflowWrap: 'break-word',
    whiteSpace: 'nowrap',
    maxWidth: 'calc(100% - 80px)',
    overflow: 'hidden',
    display: 'inline-flex',
  },
  radioCircle: {
    color: '#78909c',
  },
  infoIcon: {
    fontSize: '20px',
    marginBottom: theme.spacing(-0.8),
    marginInlineStart: theme.spacing(1),
    color: theme.palette.grey[500],
    cursor: 'pointer',
  },
  balanceBox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0.8),
    background: '#eceff1',
    border: '1px solid #2B3990',
    padding: theme.spacing(1.5),
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.09)',
    borderRadius: 8,
    backgroundImage: 'url(/images/riyal.svg)',
    backgroundPosition: '-19px center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'auto 75%',
  },
  balanceTitle: {
    color: '#263238',
    fontSize: 14,
    fontWeight: 'bold',
  },
  balancePrice: {
    color: '#263238',
    fontSize: 24,
    fontWeight: 'normal',
  },
  balancePriceText: {
    color: '#263238',
    fontSize: 12,
    fontWeight: 'normal',
    marginTop: theme.spacing(0.5),
  },
  currencyText: {
    fontSize: 15,
    paddingInlineStart: theme.spacing(1),
  },
}));